module.exports = __webpack_public_path__ + "img/icon_scan_qr_code.7e109512.png";